'use client';

import { Amplify } from 'aws-amplify';
import { authConfig, cookieStorage } from '@/lib/auth-config';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

// Configure Amplify synchronously on module load
let isConfigured = false;

function configureAmplify() {
    if (!isConfigured && typeof window !== 'undefined') {
        try {
            Amplify.configure(authConfig, { ssr: true });
            // Use cookie storage for session persistence
            cognitoUserPoolsTokenProvider.setKeyValueStorage(cookieStorage);
            isConfigured = true;
            console.log('Amplify configured with cookie storage');
        } catch (error) {
            console.error('Failed to configure Amplify:', error);
        }
    }
}

// Configure immediately when this module loads
configureAmplify();

export default function AmplifyConfig() {
    // Re-configure just in case (idempotent)
    configureAmplify();
    return null;
}

export { configureAmplify };
